/* eslint-disable no-restricted-globals */
import {
  LOCALE_PT_AO,
  LOCALE_PT_BO,
  LOCALE_PT_IE,
  LOCALE_PT_IT,
  LOCALE_PT_JP,
  LOCALE_PT_PT,
  LOCALE_PT_UK,
  LOCALE_PT_US,
} from 'commons/locale/localeConstants';

export function getCountryCodeByLocale(locale) {
  if (locale === LOCALE_PT_JP) {
    return '81';
  }
  if (locale === LOCALE_PT_US) {
    return '1';
  }
  if (locale === LOCALE_PT_UK) {
    return '44';
  }
  if (locale === LOCALE_PT_PT) {
    return '351';
  }
  if (locale === LOCALE_PT_AO) {
    return '244';
  }
  if (locale === LOCALE_PT_IE) {
    return '353';
  }
  if (locale === LOCALE_PT_BO) {
    return '591';
  }
  if (locale === LOCALE_PT_IT) {
    return '39';
  }
  return '55';
}

let defaultCountryCode = getCountryCodeByLocale();

const PhoneUtils = {
  sanitizePhoneNumberRemovePlus(phoneNumber) {
    if (!phoneNumber) {
      return '';
    }

    const normalized = `${phoneNumber
      .replace(/\+/g, '')
      .replace(/\(/g, '')
      .replace(/\)/g, '')
      .replace(/-/g, '')
      .replace(/_/g, '')
      .replace(/ /g, '')}`;
    return normalized;
  },

  sanitizePhoneNumber(phoneNumber) {
    if (!phoneNumber) {
      return '';
    }
    const normalized = `${phoneNumber
      .replace(/\(/g, '')
      .replace(/\)/g, '')
      .replace(/-/g, '')
      .replace(/_/g, '')
      .replace(/ /g, '')}`;
    return normalized;
  },
  sanitizeWithoutCountry(phoneNumber) {
    if (!phoneNumber) {
      return '';
    }
    const sanitized = this.sanitizePhoneNumber(phoneNumber);
    return sanitized.replace(/\+\d{2}/, '');
  },
  sanitizePhoneNumberWithCountryPrefix(phoneNumber) {
    let tempPhoneNumber = this.sanitizePhoneNumber(phoneNumber);
    if (tempPhoneNumber && defaultCountryCode === '55' && tempPhoneNumber.length === 10) {
      // get first digit after DDD, if >= 6 then its celular in Brazil 6-9 in Brazil means celular
      const phoneFirstDigit = Number.parseInt(tempPhoneNumber.substring(2, 3));
      // add missing digit 9
      if (phoneFirstDigit >= 6) {
        tempPhoneNumber = `${tempPhoneNumber.substring(0, 2)}9${tempPhoneNumber.substring(2)}`;
      }
    }
    return `${defaultCountryCode}${tempPhoneNumber}`;
  },
  cleanUpPhoneNumberAndGetLast8Digits(phone) {
    const sanitizedPhoneNumber = PhoneUtils.sanitizePhoneNumber(phone);
    // remove country prefix
    let phoneNumber = sanitizedPhoneNumber.replace(/\+\d{2}/, '');
    if (phoneNumber.startsWith('0')) {
      // remove 0 for local area code >> 034 becomes 34
      phoneNumber = phoneNumber.replace(/^0/, '');
    }

    // remove local area code or 9 prefix
    let justlastPartOfPhone = sanitizedPhoneNumber;
    if (sanitizedPhoneNumber.length > 8) {
      justlastPartOfPhone = justlastPartOfPhone.substr(-8);
    }
    return justlastPartOfPhone;
  },
  setLocale(localeString) {
    defaultCountryCode = getCountryCodeByLocale(localeString);
  },
};
export default PhoneUtils;
